 :current-page.sync="pageNum" <template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item><div style="display: inline-block;" @click="gotopage('/Finance/index.html')">财务管理</div></el-breadcrumb-item>
			<el-breadcrumb-item>审核对账单</el-breadcrumb-item>
		</el-breadcrumb>
		<el-form :inline="true" :model="item" class="search">
			<el-form-item label="来源">
				<el-select v-model="item.type" placeholder="请选择状态" size="small">
					<el-option label="全部" value="0"></el-option>
					<el-option label="供应商" value="1"></el-option>
					<el-option label="店铺" value="2"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="时间">
				<el-date-picker size="small" style="margin-left: 10px" v-model="item.times" type="daterange"
								range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
				</el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submit" size="medium">查询</el-button>
			</el-form-item>
		</el-form>
		<!--		数据是list 通过list展示-->
		<el-table :data="list" border>
			<el-table-column prop="id" label="ID" width="90"></el-table-column>
			<el-table-column prop="order_total" label="订单金额" width="120"></el-table-column>
			<el-table-column label="来源" width="200">
				<template slot-scope="scope">
					<span v-if="scope.row.type == 1">
						供应：{{scope.row.supplier ? scope.row.supplier.name : ''}}
					</span>
					<span v-if="scope.row.type == 2">
						店铺：{{scope.row.store ? scope.row.store.name : ''}}
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="order_count" label="订单数量" width="90"></el-table-column>
			<el-table-column prop="express_total" label="运费金额" width="120"></el-table-column>
			<el-table-column prop="refund_total" label="退款金额" width="120"></el-table-column>
			<el-table-column prop="result_totals" label="应结金额" width="120"></el-table-column>
			<el-table-column label="应结金额" width="120">
				<template slot-scope="scope">
					<span v-if="scope.row.state == 2">待平台审核</span>
					<span v-if="scope.row.state == 3">待平台结算</span>
					<span v-if="scope.row.state == 4">已完成</span>
				</template>
			</el-table-column>
			<el-table-column prop="created_date" label="时间"></el-table-column>
			<el-table-column label="操作" width="300">
				<template slot-scope="scope">
<!--					<el-popconfirm title="您确定要审核通过吗？" @confirm="goAudit(scope.row.id)" class="l10">-->
<!--						<el-button size="mini" type="primary" slot="reference">审核</el-button>-->
<!--					</el-popconfirm>-->
					<el-button style="margin-left: 10px" size="mini" type="primary" @click="look(scope.row.id)">查看明细
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page" :current-page.sync="pageNum"
			:page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>
<script>
	export default {
		name: 'index',
		data() {
			return {
				list: [],
				isLoad: false,
				pageNum: 0,
				pageSize: 20,
				total: 0,
				page: 1,
				// 查询
				item: {
					state: 2
				},
			}
		},
		created() {
			this.loadList()
		},
		methods: {
			gotopage(url){
			     var link =  this.$router.resolve({
			     path: url
			   });
			   window.open(link.href, '_blank')
			},
			loadList() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.post('/admin/finance/list', Object.assign({
					page: this.page,
					limit: this.pageSize
				}, this.item))
				.then(res => {
					this.isLoad = !this.isLoad
					// 获取数据
					this.list = res.data.list.data
					// 页数 page
					this.total = res.data.list.total
				})
				.catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			look(id) {
				this.$router.push({
					path: '/Finance/detail.html',
					query: {
						id: id
					}
				});
			},
			// 传一个ID跳转到edit页面，进行编辑
			end(id) {
				this.$router.push({
					path: '/Finance/endStatement.html',
					query: {
						id: id
					}
				});
			},
			sizeReload(val) {
				this.pageSize = val
				//   this.loadList()
			},
			pageReload(val) {
				this.page = val
				//   this.loadList()
			},
			// 搜索查询
			submit() {
				this.pageNum = 1
				this.item.page = 1
				this.loadList()
			},
			// 导出
			excelOut() {
				return;
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.get('', {
						params: {
							nickname: this.item.nickname,
							title: this.item.title
						}
					})
					.then(res => {
						this.isLoad = !this.isLoad
						// 导出
						window.open(res.url)
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			}
		},

	}
</script>
<style scoped>

</style>
